import React from 'react';
import PropTypes from 'prop-types';
import { RenderMenu } from './rendermenu';
import { NONE } from '../../modules/constants';

const OPEN_CLASS = 'open';

/**
 * List component to render a collection of menu items as a list.
 *
 * @function
 * @param       {string} aria              optional aria property string for this element.
 * @param       {array}  children          child elements of the list
 * @param       {string} className         optional className
 * @param       {boolean} hideFromMobile   optional boolean for menu items that need hiding from mobile.
 * @param       {boolean} inList           true if we are already in a list, false if we are not. Controls the render of the initial ul element.
 * @param       {string} openMenu          setState state string, empty if no menu item is open, contains the menu item name if a menu item is open.
 * @param       {boolean} openMobileMenu   true if the menu is open and the opener was the mobile burger menu button
 * @param       {string} role              Aria role of the element if appropriate. Defaults to NONE if not set.
 * @param       {function} setOpenMenu     setState function to set openMenu prop.
 * @param       {function} setOpenMobileMenu setState function to set openMobileMenu prop
 * @param       {string} text              Name of the menu item to which this list is related. Used to set open.
 * @constructor
 */
function List({
    aria,
    children,
    className,
    hideFromMobile,
    inList,
    openMenu,
    openMobileMenu,
    role,
    setOpenMenu,
    setOpenMobileMenu,
    text,
    track
}) {
    const ourClassName = [
        className,
        openMenu === text ? OPEN_CLASS : null,
        hideFromMobile && openMobileMenu ? OPEN_CLASS : null
    ]
        .join(' ')
        .trim();
    //console.log('className', ourClassName, openMenu, text);
    const renderMenuProps = {
        inList: true,
        openMenu,
        setOpenMenu,
        openMobileMenu,
        setOpenMobileMenu,
        role,
        track
    };

    if (children && children.length) {
        if (inList) {
            return (
                <li role={role || NONE}>
                    <ul className={ourClassName}>
                        <RenderMenu {...renderMenuProps}>{children}</RenderMenu>
                    </ul>
                </li>
            );
        }
        return (
            <ul aria-label={aria} className={ourClassName} role={role}>
                <RenderMenu {...renderMenuProps}>{children}</RenderMenu>
            </ul>
        );
    }

    return null;
}

List.propTypes = {
    aria: PropTypes.string,
    children: PropTypes.array,
    className: PropTypes.string,
    hideFromMobile: PropTypes.bool,
    inList: PropTypes.bool,
    menu: PropTypes.string,
    openMenu: PropTypes.string,
    openMobileMenu: PropTypes.bool,
    role: PropTypes.string,
    setOpenMenu: PropTypes.func,
    setOpenMobileMenu: PropTypes.func,
    text: PropTypes.string,
    track: PropTypes.string
};

export { List };
